import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fpgFilterItem flat-form"
}
const _hoisted_2 = { class: "fpgFilterItem-input" }
const _hoisted_3 = { class: "form-group form-group_searchSm" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 1,
  class: "dt__filter-content-selectBlock-elem"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  y: "1.11133",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(-45 0 1.11133)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "8.48535",
  y: "0.40332",
  width: "1",
  height: "12",
  rx: "0.5",
  transform: "rotate(45 8.48535 0.40332)",
  fill: "#EAEDF0"
}, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.mode === 'filter')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($options.value) = $event)),
              class: "form-control form-control-sm form-control-search",
              placeholder: $props.filter.label,
              ref: "search"
            }, null, 8 /* PROPS */, _hoisted_4), [
              [
                _vModelText,
                $options.value,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ]))
    : ($props.filter.hasValue())
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString($props.filter.value.query), 1 /* TEXT */),
          (_openBlock(), _createElementBlock("svg", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.remove && $options.remove(...args))),
            width: "10",
            height: "10",
            viewBox: "0 0 10 10",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_8))
        ]))
      : _createCommentVNode("v-if", true)
}